import { Request } from '~src/httpClient/serverApi/requests/Request';
import {IResult} from '~src/httpClient/serverApi/types/IResponse';


export interface ITestEncryptionKeyConnectionParams {
  externalKeyId: string;
}

export interface TestEncryptionKeyConnectionResult extends IResult {
  success: boolean;
  errorType: string;
  ekmsUser: string;
  latencyMs: number;
}

export class TestEncryptionKeyConnectionRequest extends Request<ITestEncryptionKeyConnectionParams, TestEncryptionKeyConnectionResult> {
  constructor(params: ITestEncryptionKeyConnectionParams) {
    super('testExternalKeyConnection', params);
  }
}